import { IMyPosMiniPlugin } from '@core/capacitor-plugins/capacitor-plugins.class';

import { MyPosMiniPlugin } from '@core/capacitor-plugins/capacitor-plugins.class';
// import { MyPosMiniPluginMock as MyPosMiniPlugin } from '@paymash/capacitor-mypos-mini-types'; // mock

const plugin = MyPosMiniPlugin as IMyPosMiniPlugin;

export { plugin as MyPosMiniPlugin };
